import { TextField } from "@mui/material";
import { GridCellParams, GridFilterInputValueProps, GridFilterOperator } from "@mui/x-data-grid-pro";
import { ChangeEvent, useImperativeHandle, useRef } from "react";

export const notContainsStringOperator: GridFilterOperator = {
  label: "does not contain",
  value: "doesNotContain",
  getApplyFilterFn: (filterItem) => {
    if (!filterItem.columnField || !filterItem.operatorValue) {
      return null;
    }

    const filterValue = filterItem.value != null ? String(filterItem.value).trim() : "";

    if (filterValue === "") {
      return null;
    }

    return (params: GridCellParams): boolean => {
      if (params.value == null) {
        return false;
      }
      const cellValue = String(params.value);
      return !cellValue.toLowerCase().includes(filterValue.toLowerCase());
    };
  },
  InputComponent: (props: GridFilterInputValueProps) => {
    const { item, applyValue, focusElementRef } = props;

    const inputRef = useRef<HTMLInputElement>(null);
    useImperativeHandle(focusElementRef, () => ({
      focus: () => {
        inputRef.current?.focus();
      },
    }));

    const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
      const newValue = event.target.value;
      applyValue({ ...item, value: newValue });
    };

    return (
      <TextField
        label="Value"
        onChange={handleFilterChange}
        placeholder="Filter value"
        inputRef={inputRef}
        slotProps={{ inputLabel: { shrink: true } }}
        value={item.value || ""}
        variant="standard"
        {...props}
      />
    );
  },
  InputComponentProps: { type: "string" },
};
